import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import * as API from "../Endpoints/Endpoints";

const ViewChakraData = () => {
  const { spokeid, bladeid } = useParams();
  const [data, setData] = useState(null);
  const [type, setType] = useState(''); 
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        let response;
        if (spokeid) {
          setType('spoke');
          response = await axios.get(API.GET_SPOKE_BYID(spokeid));
        } else if (bladeid) {
          setType('blade');
          response = await axios.get(API.GET_BLADE_BYID(bladeid));
        }
  
        if (response) {
          const item = Array.isArray(response.data) ? response.data[0] : response.data;
          setData(item);
        }
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    };
  
    fetchData();
  }, [spokeid, bladeid]);  

  if (!data) return <div className="p-4">Loading...</div>;

  return (
    <div className="p-6 max-w-3xl mx-auto bg-gray-200 shadow-lg rounded-lg">
      <h2 className="text-2xl font-bold mb-4 capitalize ">View {type}</h2>
      <form className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <label className="flex flex-col">
          Theme:
          <input readOnly value={data.theme || ''} className="border p-2 rounded" />
        </label>

        <label className="flex flex-col">
          Agent Name:
          <input readOnly value={data.agentname || ''} className="border p-2 rounded" />
        </label>

        <label className="flex flex-col md:col-span-2">
          Description:
          <textarea readOnly value={data.description || ''} className="border p-2 rounded" rows="3" />
        </label>

        <label className="flex flex-col md:col-span-2">
          Answer:
          <textarea readOnly value={data.answer || ''} className="border p-2 rounded" rows="3" />
        </label>

        {type === 'spoke' && (
          <>
            <label className="flex flex-col">
              Spoke Number:
              <input readOnly value={data.spokenumber || ''} className="border p-2 rounded" />
            </label>

            <label className="flex flex-col">
              Spoke:
              <input readOnly value={data.spoke || ''} className="border p-2 rounded" />
            </label>
          </>
        )}

        {type === 'blade' && (
          <>
            <label className="flex flex-col">
              Blade Number:
              <input readOnly value={data.bladenumber || ''} className="border p-2 rounded" />
            </label>

            <label className="flex flex-col">
              Blade:
              <input readOnly value={data.blade || ''} className="border p-2 rounded" />
            </label>
          </>
        )}

            <button
            onClick={() => navigate('/chakragametable')}
            className="mt-4 px-4 py-2 bg-[#e64a32] text-white rounded "
            >
            Go Back
            </button>

      </form>
    </div>
  );
};

export default ViewChakraData;
